module.exports = __webpack_public_path__ + "img/equipment-blue.5dea344c.svg";